import { default as de } from './de.js';
import { default as ea } from './ea.js';
import { default as es } from './es.js';
import { default as fr } from './fr.js';
import { default as it } from './it.js';
import { default as ja } from './ja.js';
import { default as nl } from './nl.js';
import { default as pb } from './pb.js';
import { default as pt } from './pt.js';
import { default as ru } from './ru.js';
import { default as zh } from './zh.js';
import { default as zi } from './zi.js';


export default {
    de: de,
    'es-419': ea,
    es: es,
    fr: fr,
    it: it,
    ja: ja,
    nl: nl,
    'pt-BR': pb,
    pt: pt,
    ru: ru,
    zh: zh,
    'zh-Hant': zi,
};
